/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/** Treat a URL as expired slightly early, so it isn't handed out just before it dies */
const EXPIRY_MARGIN_MS = 60 * 1000;

/**
 * True when a signed media URL's `Expires` param (epoch seconds) has passed, or will
 * within a short margin. URLs without a valid `Expires` param are never expired.
 */
export function isMediaUrlExpired(url: string | undefined, now = Date.now()): boolean {
    if (!url) return false;
    try {
        const expires = Number(new URL(url).searchParams.get('Expires'));
        if (!expires) return false;
        return expires * 1000 - EXPIRY_MARGIN_MS <= now;
    } catch {
        return false;
    }
}
